import { Avatar, Card, CardContent, Flex, Text } from '@pega/cosmos-react-core';
import type { AppShellProps, DrawerItemProps, ForwardProps } from '@pega/cosmos-react-core';

import { StyledMainContent } from './AppShell.styles';

export const defaultLinks: AppShellProps['links'] = [
  {
    id: '01',
    name: 'Home',
    href: '#home',
    icon: 'home-solid',
    active: true
  },
  {
    id: '02',
    name: 'My Dashboard',
    href: '#dashboard',
    icon: 'gauge-solid'
  },
  {
    id: '03',
    name: 'Spaces',
    href: '#spaces',
    icon: 'social-solid'
  },
  {
    id: '04',
    name: 'Bugs',
    href: '#bugs',
    icon: 'users-solid'
  },
  {
    id: '05',
    name: 'Epics',
    href: '#epics',
    icon: 'book-solid'
  },
  {
    id: '06',
    name: 'Goals',
    href: '#goals',
    icon: 'analytics-good'
  },
  {
    id: 'collaboration-group',
    name: 'Collaboration',
    icon: 'book',
    // FIXME: Temporary until additional interface and DOM changes can be easily adopted.
    href: '#',
    links: [
      {
        id: 'teams-link',
        name: 'Teams',
        href: '#team',
        icon: 'users-solid'
      },
      {
        id: 'documents-link',
        name: 'Documents',
        href: '#documents',
        icon: 'document'
      }
    ]
  }
];

export const defaultNotifications: (DrawerItemProps & ForwardProps)[] = [
  {
    id: '123',
    primary:
      "Dean Thomas mentioned your team in a bug 'Button does not initiate onClick event handler'.",
    secondary: ['BUG-12345', new Date(2020, 8, 31, 13, 23).toDateString()],
    visual: <Avatar name='Dean Thomas' />,
    unread: true
  },
  {
    id: '456',
    primary: "Seth DeAngelo mentioned your team in a bug 'Text variant h1 renders as h3 in DOM'.",
    visual: <Avatar name='Seth DeAngelo' />,
    unread: true
  },
  {
    id: '789',
    primary:
      "Janet Moore mentioned your team in a bug 'Tree expanded state does not match the state that was set on the component'.",
    secondary: ['BUG-12345', new Date(2020, 9, 2, 9, 22).toDateString()],
    visual: <Avatar name='Janet Moore' />,
    unread: true
  },
  {
    id: '000',
    primary: 'You have been awarded Employee of the Month! Congratulations!',
    secondary: [new Date(2020, 9, 8, 14, 46).toDateString()],
    unread: true
  }
];

export const defaultRecents: (DrawerItemProps & ForwardProps)[] = [
  {
    id: '123',
    primary: "BUG-12345: 'Button does not initiate onClick event handler'.",
    secondary: ['BUG-12345', new Date(2020, 8, 31, 13, 23).toDateString()]
  },
  {
    id: '456',
    primary: "BUG-54321: 'Text variant h1 renders as h3 in DOM'."
  },
  {
    id: '789',
    primary:
      "BUG-00000: 'Tree expanded state does not match the state that was set on the component'.",
    secondary: ['BUG-00000', new Date(2020, 9, 2, 9, 22).toDateString()]
  },
  {
    id: '111',
    primary: "BUG-12345: 'Button does not initiate onClick event handler'.",
    secondary: ['BUG-12345', new Date(2020, 8, 31, 13, 23).toDateString()]
  },
  {
    id: '222',
    primary: "BUG-54321: 'Text variant h1 renders as h3 in DOM'."
  },
  {
    id: '333',
    primary:
      "BUG-00000: 'Tree expanded state does not match the state that was set on the component'.",
    secondary: ['BUG-00000', new Date(2020, 9, 2, 9, 22).toDateString()]
  },
  {
    id: '444',
    primary: "BUG-12345: 'Button does not initiate onClick event handler'.",
    secondary: ['BUG-12345', new Date(2020, 8, 31, 13, 23).toDateString()]
  },
  {
    id: '555',
    primary: "BUG-54321: 'Text variant h1 renders as h3 in DOM'."
  },
  {
    id: '666',
    primary:
      "BUG-00000: 'Tree expanded state does not match the state that was set on the component'.",
    secondary: ['BUG-00000', new Date(2020, 9, 2, 9, 22).toDateString()]
  }
];

export const defaultMainContent = (
  <Flex container={{ justify: 'center', alignItems: 'center' }} as={StyledMainContent}>
    <Card>
      <CardContent>
        <Text variant='h1'>This is the main content</Text>
      </CardContent>
    </Card>
  </Flex>
);

export const operatorData = {
  avatar: <Avatar name='Cindy Turner' />,
  actions: [
    { primary: 'Profile', id: 'profile' },
    { primary: 'Settings', id: 'settings' },
    { primary: 'My applications', id: 'apps' },
    { primary: 'Help center', id: 'help' },
    { primary: 'Log out', id: 'logout' }
  ],
  name: 'Cindy Turner'
};

export const defaultCases = [
  {
    primary: 'Phone interaction 1',
    secondary: 'Received 40s ago',
    collapsedItemInfo: 'I-4123567',
    createdAt: 1626789059860,
    id: 'demo-phone-interaction_1',
    active: false
  },
  {
    primary: 'Chat interaction 3',
    secondary: 'Sent 2h ago',
    createdAt: 1626789063045,
    id: 'demo-chat-interaction_1',
    active: false
  }
];
